/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../Store/action";
import { CALL_ACTION_TYPE } from "../../../Store/call/Type";
import Message from "../../forms/fields/Message";
import { BsSend } from "react-icons/bs";

const SendMessageOnboarding = ({ 
  user,
  userpro,
  setStep,
  isPdfDownloaded,
  questionnaireState,
  license,
  taxpro_allow_appointments,
  isAppointmentBooked,
  isVerify
 }) => {
  const dispatch = useDispatch();
  const [message, setMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const group = false;
  const [profile, { chatStatus,writePersonalReplyStatus, writePersonalReplyMessage, personalConnections, writePersonalStatus, writePersonalMessage }] = useSelector(
    (state) => [state.dashboard, state.firebase]
  );

  let myIds = [
    group && !group?.includes(undefined)
      ? group.find((data) => data !== userpro?.user?.uuid)
      : user?.uuid,
      userpro?.user?.uuid,
  ];

  

  const handleSend = (messageText) => {
    if (!messageText?.trim() || !userpro) return;

    const filteredConnection = personalConnections?.data?.filter(
      (data) => data?.ids?.includes(myIds[1]) && data?.ids?.includes(myIds[0])
    );
 if (filteredConnection.length === 0) { 
		
      let topicObject = {
        title: "General Chat Room",
        // Check if Meeting link Exist use this otherwiste use messageContent
        body: messageText,
        senderId: user?.uuid,
        receiverId: userpro?.user?.uuid,
        createdAt: new Date(),
        draft: [],
        updatedAt: new Date(),
        isTyping: [user?.uuid],
        messageType: 'simple',
      };
      let addMessage = true;
      dispatch(
        allActions.firebase.writeChatPersonalConnection(topicObject, addMessage)
      );
    } else {

      const chatObject = {
        body: messageText,
        senderId: user?.uuid,
        receiverId: userpro?.user?.uuid,
        createdAt: new Date(),
        messageType: "simple",
        images: [],
      };

      const updateChatConn = {
        [userpro?.uuid]: filteredConnection?.[0]?.[userpro?.uuid] + 1,
        updatedAt: new Date(),
      };

      dispatch(
        allActions.firebase.writeChatPersonalReply(
          chatObject,
          filteredConnection?.[0]?.docId,
          updateChatConn
        )
      );
    }
    const status = allActions.firebase.getMyStatus(chatStatus?.data, userpro?.uuid, "status");
    if (status !== "online") {
      dispatch(
        allActions.sgMail.sendMailReminder({
          customerEmail: userpro?.user?.email,
          operatorFirstname: user?.firstname,
          operatorAvatar: user?.avatar[0]?.path,
          shortenedMessage: messageText,
          accountId: user?.uuid,
          phone: user?.phone,
        })
      );
    }

    setMessage("");
  };  

  useEffect(() => {
    if (writePersonalReplyStatus === false) {
      setAlertMessage({
        show: true,
        type: "Error",
        text: writePersonalReplyMessage,
      });
    }
    if (writePersonalReplyStatus === true) {
      setAlertMessage({
        show: true,
        type: "Success",
        text: writePersonalReplyMessage,
      });

      const profileObj = {
        settings: {
          ...user?.settings,
          firstMessageSent: true,
        },
      };

      dispatch(
        allActions.dashboard.updateProfile({
          uuid: user?.uuid,
          profileObj,
        })
      );

      setTimeout(() => {
        setStep((prev) => {
           if(isPdfDownloaded){
            return prev + 2;
          }else{
            return prev + 1;
          }
        });
      }, 2000);

      dispatch(allActions.call.dispatchToStore({ type: CALL_ACTION_TYPE.videoCallRoomIdle }));
    }
  }, [writePersonalReplyStatus, writePersonalReplyMessage, writePersonalStatus, writePersonalMessage]);

    useEffect(() => {
    if (writePersonalStatus === false) {
      setAlertMessage({
        show: true,
        type: "Error",
        text: writePersonalMessage,
      });
    }
    if (writePersonalStatus === true) {
      setAlertMessage({
        show: true,
        type: "Success",
        text: writePersonalMessage,
      });

      const profileObj = {
        settings: {
          ...user?.settings,
          firstMessageSent: true,
        },
      };

      dispatch(
        allActions.dashboard.updateProfile({
          uuid: user?.uuid,
          profileObj,
        })
      );

      setTimeout(() => {
        setStep((prev) => prev + 1);
      }, 2000);

      dispatch(allActions.call.dispatchToStore({ type: CALL_ACTION_TYPE.videoCallRoomIdle }));
    }
  }, [ writePersonalStatus, writePersonalMessage]);
  useEffect(() => {
    if (profile?.state === true) {
      dispatch(allActions.user.ReGetUserData());
    }
  }, [profile.state]);


    const handleBack = () => {

    if (questionnaireState?.value !== questionnaireState?.max) {
      setStep(6);
      return;
    }

    if (!license) {
      setStep(5);
      return;
    }

    if (taxpro_allow_appointments && !isAppointmentBooked) {
      setStep(4);
      return;
    }

    if (!isVerify) {
      setStep(3);
      return;
    }

    if (!user?.settings?.isPasswordChanged) {
      setStep(2);
      return;
    }

    setStep(1);
  };

  return (
    <div className="container d-flex flex-column align-items-center text-center mt-2" >
      {alertMessage.show && <Message message={alertMessage} />}

      <h3 className="fw-bold text-primary  mb-1 fs-2">
        Start The Conversation
      </h3>
      {/* <p className="mb-3 fs-4" style={{ maxWidth: "400px" }}>
        Complete all steps to get <span className="text-success fw-bold">$25 Off</span> on your first tax service
      </p> */}

      <p className="fw-semibold mb-2">Talk to your tax pro</p>

      <div className="d-flex w-100 bg-light rounded px-2 py-2 align-items-center mb-5" style={{ maxWidth: "600px" }}>
        <input
          type="text"
          className="form-control border-0 bg-transparent outline-0"
          placeholder="What is the #1 burning question you have for your tax pro call?"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ fontSize: "15px", color: "#333" }}
        />
        <button
          className="btn btn-primary btn-sm px-3 py-2 rounded d-flex  align-items-center gap-2"
          disabled={!message}
          onClick={() => handleSend(message)}
        > 
          Send  <BsSend />
        </button>
      </div>

      <div className="d-flex justify-content-between w-100">
        <button className="btn btn-outline-primary px-4" onClick={handleBack}>
          ← Back
        </button>
        <button className="btn btn-primary px-4" 
        onClick={() => setStep((prev) => {
          if(isPdfDownloaded){
            return prev + 2;
          }else{
            return prev + 1;
          }
        })}
        disabled={writePersonalReplyStatus === true}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default SendMessageOnboarding;
